import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient from '../httpClient';

export const useStatusCriterio = () => {
  const [statusCriterio, setStatusCriterio] = useState<EnumOption[]>([]);

  useEffect(() => {
    const fetchStatusCriterio = async () => {
      try {
        const response = await httpClient.get(
          `/api/medsuscriterio/statuscriterio`,
        );

        const options = response.data.map(
          (statusCriterio: { value: number; label: string }) => ({
            value: statusCriterio.value.toString(),
            label: statusCriterio.label,
          }),
        );
        setStatusCriterio(options);
      } catch (error) {
        console.error('Erro ao buscar Status Criterio', error);
      }
    };

    fetchStatusCriterio();
  }, []);

  return statusCriterio;
};
